import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------

import { buscarPostagensService } from "../services/buscarPostagensService";

export const useBuscarPostagens = () => {
  const [postagens, setPostagens] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetch = async () => {
    setIsLoading(true);
    const data = await buscarPostagensService();

    setPostagens(data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetch();
  }, []);
  // Retorna as variáveis de estado para o componente que utiliza este hook
  return { postagens, isLoading, fetch };
};
